<template>
  <div>
    <!-- :button="{ label: 'Documentation', action: integrationAction, icon: SBIconList.ARROW }" -->
    <ChannelHeader
      :image="integration && integration.icons ? integration.icons.dark : ''"
      :background-color="integration.iconBackgroundColor"
      :link="integration.numberInfo"
      :title="integration.name"
      :active="!!(integration.active && frontInboxes.length)"
      @activate="activate"
      @deactivate="disconnectFront" />

    <template v-if="integration.active && frontInboxes.length">
      <h3 v-if="integration.voicePlugin">Voice plugin</h3>
      <b-form-group v-if="integration.voicePlugin">
        <CopyInput
          :value="integration.voicePlugin"
          :icon-button="true" />
      </b-form-group>
      <h3>Connected inboxes {{ integration.accountName ? 'in ' + integration.accountName : '' }}</h3>
      <div
        v-for="(item, index) in frontInboxes"
        :key="index"
        class="item-wrapper" >
        <div
          class="item flex"
          @click="toFront(item)" >
          <p
            class="mr-2 greedy ellipsis"
            :class="{ 'no-name': !item.inbox_name}">{{ item.inbox_name || 'No name' }}</p>
          <SBIcon
            class="hover-arrow"
            :icon="SBIconList.ARROW_LONG"
            :color="SBColors.greyPrimary"
            :size="14"
            :rotate="-45" />
        </div>
        <SBIcon
          class="on-parent-hover trash"
          :icon="SBIconList.TRASH"
          :color="SBColors.blackUltralight"
          :size="10"
          :hover-size="22"
          :pointer="true"
          :border-radius="30"
          :hover-icon-color="SBColors.blackPrimary"
          @click.native.stop
          @click="disconnectInbox(item)" />
      </div>
      <div
        class="new-inbox-btn"
        @click="addNewInbox">
        <span class="flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.PLUS"
            :color="SBColors.bluePrimary"
            :size="8" />
          <span>New inbox</span>
        </span>
      </div>
    </template>

    <ConnectFeature
      v-else-if="integration.icons"
      :image="integration.icons.dark"
      icon-background="#fff8fa"
      :connect-text="integration.startNewText"
      @start="activate" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import CopyInput from '@/components/common/CopyInput';
import ToasterMixin from '@/mixins/Toaster';
import ChannelHeader from './ChannelHeader';
import ConnectFeature from './ConnectFeature';

export default {
  name: 'SBFManage',
  components: {
    ChannelHeader,
    ConnectFeature,
    CopyInput,
    SBIcon,
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      integrationsRegistryData: 'organisation/integrationsRegistryData',
      numberIntegrationMap: 'organisation/numberIntegrationMap',
      numberIntegrationData: 'organisation/numberIntegrationData',
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    business() {
      return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.businessId);
    },
    frontInboxes() {
      let inboxes = [];
      try {
        inboxes = [...this.integrationsRegistryData.find(ird => ird.code === 'FRONTPACHA').organisation_specific_data.business[this.business.id]];
      } catch (error) { }

      return inboxes;
    },
    integration() {
      let iData = {};
      let iReg;
      try {
        iReg = this.integrationsRegistryData.find(ird => ird.code === 'FRONTPACHA');
      } catch (error) {
        iReg = [];
      }
      if (iReg) {
        iData = {
          name: iReg.name,
          icons: iReg.icons,
          iconBackgroundColor: '#fcf5f5',
          numberInfo: iReg.data.number_blog_url,
          integrationUrl: iReg.data.web_app_url,
          active: !!this.frontInboxes.length,
          startNewText: iReg.data.connect_description,
          learnMoreLink: iReg.data.number_blog_url,
          connectUrl: iReg.data.connect_url,
          voicePlugin: iReg.organisation_specific_data && iReg.organisation_specific_data.voice_plugin ? iReg.organisation_specific_data.voice_plugin.url : '',
          accountName: iReg.organisation_specific_data ? iReg.organisation_specific_data.name : '',
        };
      }

      return iData;
    },
  },
  mounted() {
    this.fetchIntegrationsRegistry();
  },
  methods: {
    ...mapActions({
      deleteFrontChannel: 'integration/deleteFrontChannel',
      deleteAllFrontChannels: 'integration/deleteAllFrontChannels',
      fetchIntegrationsRegistry: 'organisation/fetchIntegrationsRegistry',
    }),
    integrationAction() {},
    disconnectInbox(inbox) {
      this.$confirmPluginModal.show({
        buttonVariant: 'RED',
        title: 'Disconnect channel',
        message: `Are you sure you want to disconnect the AI Number WhatsApp channel named <b>${inbox.inbox_name}</b> from Front? After disconnecting, no future messages will be imported or fetched from Front.`,
        confirmButtonText: 'Disconnect',
        showUndoWarning: false,
        confirmCallback: () => {
          this.$confirmPluginModal.close();
          this.deleteFrontChannel({ ...inbox, numberId: this.business.id })
            .then((response) => {
              if (response.status === 200) {
                this.showToaster(`${inbox.inbox_name} has been successfully deleted.`, null, null, 'OK');
              } else {
                this.showToaster('There was an issue, and the Front inboxes were not disconnected. Please try again.', null, null, 'error');
              }
            });
        },
      });
    },
    disconnectFront() {
      this.$confirmPluginModal.show({
        buttonVariant: 'RED',
        title: 'Disconnect all channels',
        message: 'Are you sure you want to disconnect <b>all</b> AI Number WhatsApp channels from Front? After disconnecting, no future messages will be imported or fetched from Front.',
        confirmButtonText: 'Disconnect',
        showUndoWarning: false,
        confirmCallback: () => {
          this.$confirmPluginModal.close();
          const numberOfInboxes = this.frontInboxes.length;
          const firstInboxName = this.frontInboxes[0].inbox_name || 'Front inbox';
          this.deleteAllFrontChannels(this.business.id)
            .then((response) => {
              if (response.status === 200) {
                if (numberOfInboxes > 1) {
                  this.showToaster('All inboxes have been successfully deleted.', null, null, 'OK');
                } else {
                  this.showToaster(`${firstInboxName} has been successfully deleted.`, null, null, 'OK');
                }
              } else {
                this.showToaster('There was an issue, and the Front inboxes were not disconnected. Please try again.', null, null, 'error');
              }
            });
        },
      });
    },
    activate() {
      window.open(this.integration.connectUrl, '_blank');
    },
    addNewInbox() {
      this.activate();
    },
    toFront() {
      window.open('https://app.frontapp.com', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 20px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;

  &:first-of-type {
    margin-top: 35px;
  }
}

.new-inbox-btn {
  display: inline-block;
  color: $bluePrimary;
  margin: 4px 0 0 0;
  padding: 9px 0px;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }
}

::v-deep .input-group {
  input {
    height: 32px;
  }

  .input-group-append .btn {
    padding: 6px 10px !important;
  }
}

.item-wrapper {
  margin-right: -40px;
  padding-right: 40px;
  position: relative;

  .sb-icon.on-parent-hover {
    display: none;
    position: absolute;
    top: 6px;
    right: 10px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    border: solid 1px $greyBorder;
  }

  &:hover .sb-icon.on-parent-hover {
    display: flex;

    &:hover {
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
    }
  }

  .no-name {
    color: #9eafb5;
  }
}

.item {
  margin-top: 12px;
  padding: 7px 10px 7px 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  background-color: $white;

  &:last-of-type {
    margin-bottom: 5px;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackPrimary;
    line-height: 1.2;
  }

  .hover-arrow {
    display: none;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);

    .hover-arrow {
      display: initial;
    }
  }
}
</style>
